// import components
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// import types
import { DutyCodePeriod } from 'generated';
import { Period } from '../../../../admin-portal/Settings/DutyCodes/type';

// import utils
import { compareAsc, parseISO } from 'date-fns';
import { formatTime } from 'utils/date';

const PREFIX = 'DutyCodePeriods';

const classes = {
  container: `${PREFIX}-container`,
  periodTime: `${PREFIX}-periodTime`,
  dash: `${PREFIX}-dash`,
  description: `${PREFIX}-description`
};

const Root = styled('div')(() => ({
  [`& .${classes.container}`]: {
    display: 'flex',
    width: '95px',
    justifyContent: 'space-between'
  },

  [`& .${classes.periodTime}`]: {
    width: '30px',
    textAlign: 'left'
  },

  [`& .${classes.dash}`]: {
    width: '10px',
    textAlign: 'center'
  },

  [`& .${classes.description}`]: {
    width: 150
  }
}));

interface Props {
  periods: Period[] | DutyCodePeriod[];
  periodId: string;
}

const sortByStartTime = (a, b) => {
  return compareAsc(parseISO(a.startTime), parseISO(b.startTime));
};

export const DutyCodePeriods = (props: Props) => {
  const { periods, periodId } = props;

  return (
    <Root>
      {periods.sort(sortByStartTime).map((period) => (
        <div key={period[periodId]}>
          <Box display="flex" gap={2.5} my={0.5}>
            <div className={classes.container}>
              <div className={classes.periodTime}>
                {formatTime(period.startTime)}
              </div>
              <div className={classes.dash}>-</div>
              <div className={classes.periodTime}>
                {formatTime(period.endTime)}
              </div>
            </div>
            <div className={classes.description}>
              {period.dutyHourType?.description}
            </div>
          </Box>
        </div>
      ))}
    </Root>
  );
};
